import { render } from "./HighlightsWidget.vue?vue&type=template&id=fb862bd4"
import script from "./HighlightsWidget.vue?vue&type=script&lang=js"
export * from "./HighlightsWidget.vue?vue&type=script&lang=js"

import "./HighlightsWidget.vue?vue&type=style&index=0&id=fb862bd4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__